<script setup lang="ts">
import { computed } from 'vue'
import { avatarToneFor } from '../internal/avatar.ts'

const props = withDefaults(defineProps<{ id: string; name: string; size?: 'md' | 'lg' }>(), {
  size: 'md',
})

const initial = computed(() => props.name.trim().charAt(0).toUpperCase() || '?')
const tone = computed(() => `var(${avatarToneFor(props.id)})`)

const SIZE_CLASSES = {
  md: 'h-10 w-10 text-[length:var(--text-step-3)]',
  lg: 'h-14 w-14 text-[length:var(--text-step-5)]',
} as const
</script>

<template>
  <span
    aria-hidden="true"
    class="flex shrink-0 items-center justify-center rounded-full font-semibold text-[color:var(--color-text)]"
    :class="SIZE_CLASSES[size]"
    :style="{ backgroundColor: `color-mix(in srgb, ${tone} 22%, var(--color-surface))` }"
  >
    {{ initial }}
  </span>
</template>
